// extracted by mini-css-extract-plugin
export default {"contactWrapper":"Contact_contactWrapper__UZy+U","contactSection":"Contact_contactSection__9hhCi","contentBox":"Contact_contentBox__kq3W9"};